import { AppRoutePath, ReporterRoutePath } from 'config/constants';
import { PageTypes } from '@sironamedical/common';
import { Tab } from 'hooks/useOpenTabsUtils';

export const generateProxyUrl = (url: string, apiGatewayUrl: string): string => {
  return url.startsWith('http') ? url : `${apiGatewayUrl}${url}`;
};

export const generateNestedReporterUrl = (subPath: ReporterRoutePath, isBlank?: boolean) => {
  return `${isBlank ? AppRoutePath.REPORTER_BLANK : AppRoutePath.REPORTER}/${subPath}`;
};

export const getPatientJacketBasePath = (isDocked: boolean, isBlank?: boolean): string => {
  if (isDocked) {
    return AppRoutePath.PATIENT_JACKET;
  }

  return isBlank ? AppRoutePath.PATIENT_JACKET_BLANK : AppRoutePath.PATIENT_JACKET_UNDOCKED;
};

export const getBlankRoute = (pageType: PageTypes): Nullable<string> => {
  switch (pageType) {
    case PageTypes.VIEWER:
      return AppRoutePath.VIEWER_BLANK;
    case PageTypes.REPORTER:
      return AppRoutePath.REPORTER_BLANK;
    case PageTypes.PATIENT_JACKET:
      return AppRoutePath.PATIENT_JACKET_BLANK;
    case PageTypes.AI_SANDBOX:
      return AppRoutePath.AI_SANDBOX_BLANK;
    default:
      return null;
  }
};

const BLANK_ROUTES = [
  AppRoutePath.PATIENT_JACKET_BLANK,
  AppRoutePath.VIEWER_BLANK,
  AppRoutePath.REPORTER_BLANK,
  AppRoutePath.AI_SANDBOX_BLANK,
];

export const isAnyBlankRouteOpen = (tabs: Array<Tab>) => {
  function routeToRegex(route: string): RegExp {
    const pattern = route.replace(/:[^/]+/g, '[^/]+').replace(/\//g, '\\/');

    return new RegExp(`^${pattern}$`);
  }

  const BLANK_ROUTE_REGEXES = BLANK_ROUTES.map(routeToRegex);

  return tabs.some((tab) => {
    const path = tab.path ?? new URL(tab.url ?? '').pathname;
    return BLANK_ROUTE_REGEXES.some((regex) => regex.test(path));
  });
};
